/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAttachTagsDto } from '../../models/lexplus-attach-tags-dto';
import { LexplusTagKontextEnum } from '../../models/lexplus-tag-kontext-enum';
import { LexplusTagMiniDto } from '../../models/lexplus-tag-mini-dto';

export interface TagsControllerAttachV1$Params {
  kontextID: number;
  kontext: LexplusTagKontextEnum;
      body: LexplusAttachTagsDto
}

export function tagsControllerAttachV1(http: HttpClient, rootUrl: string, params: TagsControllerAttachV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusTagMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, tagsControllerAttachV1.PATH, 'put');
  if (params) {
    rb.path('kontextID', params.kontextID, {});
    rb.path('kontext', params.kontext, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusTagMiniDto>>;
    })
  );
}

tagsControllerAttachV1.PATH = '/v1/tags/{kontext}/{kontextID}';
